module.exports = __webpack_public_path__ + "static/media/settings.9a31c0bd.svg";